import { render, staticRenderFns } from "./CreativesWrapper.vue?vue&type=template&id=818d69b2&scoped=true"
import script from "./CreativesWrapper.vue?vue&type=script&lang=js"
export * from "./CreativesWrapper.vue?vue&type=script&lang=js"
import style0 from "./CreativesWrapper.vue?vue&type=style&index=0&id=818d69b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "818d69b2",
  null
  
)

export default component.exports